import { Alert } from "@mui/material";

// Progress (info), "still running" / skipped rows (warning) and errors for a Phase A run.
const PhaseAStatusAlerts = ({ state }) => (
  <>
    {state.loading && state.statusMessage && (
      <Alert severity="info" sx={{ mt: 2, borderRadius: 2 }}>
        {state.statusMessage}
      </Alert>
    )}
    {state.notice && (
      <Alert severity="warning" sx={{ mt: 2, borderRadius: 2 }}>
        {state.notice}
      </Alert>
    )}
    {state.error && (
      <Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>
        {state.error}
      </Alert>
    )}
  </>
);

export default PhaseAStatusAlerts;
